import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SurveyBuilderHelpContentComponent } from './survey-builder-help-content.component';
import { FormsModule } from "@angular/forms";
import { TagsModule } from '@xref/xref-lib';

@NgModule({
  declarations: [SurveyBuilderHelpContentComponent],
  imports: [
    CommonModule,
    FormsModule,
    TagsModule
  ],
  exports: [SurveyBuilderHelpContentComponent]
})
export class SurveyBuilderHelpContentModule { }
